import React from "react";
import { dotStream } from "ldrs";
dotStream.register();

const MirageLoader = () => {
  return (
    <>
      <l-dot-stream size="60" speed="2.5" color="white"></l-dot-stream>
    </>
  );
};

export default MirageLoader;
